export const SearchParamKey = {
  FEEDBACK_ID: 'feedback-id',
  USER_EMAIL: 'user-email',
  POLICY_ID: 'policy-id',
  USER_NAME: 'user-name',
  CLAIM_ID: 'claim-id',
  SOURCE: 'source',
  USER_FEEDBACK: 'user-feedback',
  LOB: 'lob',
  FORM: 'form',
  MOBILE: 'mobile',
  PROPOSAL_ID: 'proposal-id',
}
